var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2342_2324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2177 0L17.7694 6.65217H4.66602L11.2177 0Z",
    fill: "#00067E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2177 22.9569L17.7694 16.3047H4.66602L11.2177 22.9569Z",
    fill: "#00067E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69629 8.86914H17.2289",
    stroke: "#00067E",
    strokeWidth: 1.04348
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69629 11.4785H17.2289",
    stroke: "#00067E",
    strokeWidth: 1.04348
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69629 14.0869H17.2289",
    stroke: "#00067E",
    strokeWidth: 1.04348
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2342_2324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1304,
    height: 22.9565,
    fill: "white",
    transform: "translate(3.65234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default __webpack_public_path__ + "static/media/reorder.b7dab77d5f05b1c3cfd431f236ccf243.svg";
export { ForwardRef as ReactComponent };